import { Component, OnInit, ViewChild } from '@angular/core';
import { ClientesService } from '../service/clientes.service';
import { Cliente } from '../model/cliente.model';
import { Router } from '@angular/router';
import { VerificarPermissoes } from './../model/verificarPermissoes.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MapaShapeDialogComponent } from '../mapa-shape-dialog/mapa-shape-dialog.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ShapeService } from '../service/shape.service';
import { ShapeResponse } from '../model/shape.model';

@Component({
  selector: 'app-shapes',
  templateUrl: './shapes.component.html',
  styleUrls: ['./shapes.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      )
    ])
  ]
})
export class ShapesComponent implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  dataSource = new MatTableDataSource<any>();

  public clientes!: Cliente[];
  public clientesFormatados: any[] = [];
  public validaResp: boolean = false;
  public load: boolean = false;
  public clientesId: number = 0;
  public formulario!: FormGroup;

  public columnsToDisplay = [
    'fazenda',
    'area_total',
    'quantidade_talhoes',
    'ultimaAtualizacao',
    'acaoMapa',
    'expandir'
  ];

  expandedElement: any | null = null;
  ultimoShape: any = null;

  constructor(
    private serviceCliente: ClientesService,
    private router: Router,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private shapeService: ShapeService
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.listarCliente();

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const dataStr = `
        ${data.vc_nome}
        ${data.area_total}
        ${data.quantidade_talhoes}
      `.toLowerCase();

      const talhoesStr = data.talhoes
        ?.map((t: any) => t.vc_nome.toLowerCase())
        .join(' ') || '';

      return dataStr.includes(filter) || talhoesStr.includes(filter);
    };
  }

  createForm() {
    this.formulario = this.formBuilder.group({
      fk_cliente: [this.clientesId || '', Validators.required],
    });
  }

  limparTela(): void {
    this.dataSource.data = [];
    this.ultimoShape = null;
    this.expandedElement = null;
    this.validaResp = false;
  }

  listarCliente(): void {
    this.load = true;

    this.serviceCliente.listarServiceClientes().subscribe({
      next: (resp) => {
        this.clientes = resp;

        this.clientesFormatados = this.clientes.map(cliente => ({
          id: cliente.sr_id,
          nome: cliente.vc_nome
        }));

        const clienteStorage = localStorage.getItem('cliente');

        if (clienteStorage) {
          this.clientesId = Number(clienteStorage);

          this.formulario.patchValue({
            fk_cliente: this.clientesId
          });

          this.listarShapesFazendasPorCliente(this.clientesId);
        } else {
          this.load = false;
        }
      },
      error: (error) => {
        this.load = false;

        if (error === '401') {
          localStorage.removeItem('token');
          this.router.navigate(['/']);
        }
      }
    });
  }

  onClienteSelecionado(clienteId: number | string): void {
    
    this.limparTela();

    if (typeof clienteId === 'number') {
      this.clientesId = clienteId;

      localStorage.setItem('cliente', clienteId.toString());

      this.formulario.patchValue({
        fk_cliente: clienteId
      });

      this.listarShapesFazendasPorCliente(clienteId);

    } else {
      this.clientesId = 0;
      localStorage.removeItem('cliente');
    }
  }

  listarShapesFazendasPorCliente(clienteId: number): void {

    this.limparTela();
    this.load = true;

    this.shapeService
      .listarShapesFazendasPorCliente(clienteId)
      .subscribe({
        next: (resp: ShapeResponse) => {

          this.ultimoShape = resp?.ultimo_shape ?? null;

          const fazendas = resp?.fazendas ?? [];

          this.dataSource.data = fazendas;
          this.dataSource.paginator = this.paginator;

          this.validaResp = fazendas.length === 0;
          this.load = false;
        },
        error: (error) => {
          this.load = false;
          this.validaResp = true;

          if (error.status === 401) {
            localStorage.removeItem('token');
            this.router.navigate(['/']);
          }
        }
      });
  }

  public verificarPermissao(permissoesFuncionalidades: string[]): boolean {
    const permissaoUsuario = localStorage.getItem('permissoes');

    return VerificarPermissoes.temPermissao(
      permissoesFuncionalidades,
      permissaoUsuario
    );
  }

  visualizarMapa(shape: any): void {
    this.dialog.open(MapaShapeDialogComponent, {
      width: '90vw',
      height: '90vh',
      maxWidth: '1400px',
      data: {
        fazenda: shape.vc_nome,
        area_total: shape.area_total,
        quantidade_talhoes: shape.quantidade_talhoes,
        ultimoShape: shape.shape.vc_nome_original,
        shapeSha1: shape.shape.vc_sha1,
        fk_cliente: shape.fk_cliente,
        link_assinado: shape.shape.link_assinado
      }
    });
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}